var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1173_54483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H21V21H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1173_54483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83008 20.4531C12.9043 20.4531 15.3965 17.961 15.3965 14.8867C15.3965 13.5715 14.9403 12.3257 14.1776 11.3731L9.83008 5.94336L5.48257 11.3731C4.71982 12.3257 4.26367 13.5715 4.26367 14.8867C4.26367 17.961 6.75583 20.4531 9.83008 20.4531Z",
    stroke: "#737373",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83008 18.2266C7.98838 18.2266 6.49023 16.7284 6.49023 14.8867",
    stroke: "#737373",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 8.72656C15.2818 8.72656 14.2832 7.72799 14.2832 6.5C14.2832 5.98848 14.4512 5.50795 14.7692 5.11111L16.5098 2.90759L18.2503 5.11111C18.5684 5.50795 18.7363 5.98848 18.7363 6.5C18.7363 7.72799 17.7378 8.72656 16.5098 8.72656Z",
    stroke: "#737373",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrops);
export default __webpack_public_path__ + "static/media/Drops.cfb667c74df48d5eca43d8a703903447.svg";
export { ForwardRef as ReactComponent };